import { render, staticRenderFns } from "./MotherList.vue?vue&type=template&id=cc09c8f8"
import script from "./MotherList.vue?vue&type=script&lang=js"
export * from "./MotherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports